<ng-container *transloco="let t">
  @let couponDiscountValue = couponDiscount();

  <form novalidate (submit)="validateCoupon($event)" class="ui-input">
    <div class="coupon-input">
      <pxw-input-text
        #couponInput="ngModel"
        name="couponCode"
        class="coupon-input-field"
        [label]="t('endOrder.couponCodeLabel')"
        [ngModel]="couponCode()"
        (ngModelChange)="onCouponCodeChange($event)"
        [displayErrors]="isFormSubmitted()"
        pattern="^[a-zA-Z0-9_]*$"
        [disabled]="validatingCoupon() || !!couponDiscountValue"
      >
        <div class="addon-append">
          @if (couponDiscountValue) {
            <pxw-icon
              class="coupon-remove-button ui-clickable"
              icon="close"
              color="danger"
              (click)="removeCoupon()"
            ></pxw-icon>
          } @else {
            <pxw-button
              class="coupon-input-button"
              color="yellow"
              [loading]="validatingCoupon()"
              [disabled]="!couponInput.valid"
              (click)="validateCoupon($event)"
              [rounded]="true"
              mode="submit"
            >
              {{ t('endOrder.couponCodeValidate') }}
            </pxw-button>
          }
        </div>
      </pxw-input-text>
    </div>
    <p class="ui-helper">{{ t('endOrder.couponCodeHelper') }}</p>

    @if (couponDiscountValue) {
      <pxw-alert type="success" size="sm" display="inline-block" style="margin-bottom: 1em">
        <pxw-icon icon="price-discount" #customIcon />
        {{ t('endOrder.couponCodeAppliedDiscountLabel') }}:
        <strong>{{ couponDiscountValue | currencyFormat }}</strong>
      </pxw-alert>
    }
  </form>

  <pxw-coupon-validation-errors-dialog />
</ng-container>
